import { Component } from '@angular/core';

@Component({
  selector: 'app-content-card10',
  imports: [],
  templateUrl: './content-card10.component.html',
  styleUrl: './content-card10.component.scss'
})
export class ContentCard10Component {

}